<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">{{isForTruck?'Römork':'Treyler'}}</label>
            <v-select-list :disabled="trailers.length == 0" :placeholder="isForTruck?'Römork':'Treyler'" v-model="trailer" label="Info" :options="trailers"/>
        </div>
    </div>
</template>

<script>
import VehicleOperationsApi from '@/api/vehicle-operations'
export default {
    components:{
    },
    props:{
        value:Object,
        isForTruck:Boolean
    },
    data() {
        return {
            trailers:[]
        }
    },
    mounted(){
        this.getNotAssignedTrailers()
    },
    methods:{
        getNotAssignedTrailers(){
            VehicleOperationsApi.Operational.GetNotAssignedTrailer(this.isForTruck).then(response=>{
                this.trailers = response.data.Data
            })
        }
    },
    computed:{
        trailer:{
            get:function(){
                return this.trailers.find(b=>b.Id==this.value.TrailerVehicleInventoryId)
            },
            set:function(value){
                this.value.TrailerVehicleInventoryId = value?.Id || null
            }  
        }
    }
}
</script>

<style lang="scss">
</style>